<template>
  <div class="details">
    <i class="el-icon-close" style="position: absolute;left: 3px; top: 5px; font-size: 25px; cursor: pointer;" @click="$emit('close')" />
    <div class="details_add">
      <div class="add_item">
        <span class="item_title">部门名称</span>
        <span class="item_non">{{ drawerItem.name }}</span>
      </div>
      <div class="add_item">
        <span class="item_title">管理员</span>
        <el-select v-model="addParameter.user_id" placeholder="请选择" filterable :disabled="isP" @clear="addParameter.user_id = null">
          <el-option
            v-for="item in tableData.user"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-button type="primary" style="margin-left: 310px" @click="addPitcher">添加</el-button>
    </div>
    <div class="details_contentArea">
      <el-table
        v-loading="loading"
        :data="alltableData.list"
        max-height="300"
        border
        style="width: 80%; margin:0 auto;"
      >
        <el-table-column
          prop="admin_id"
          label="用户id"
        />
        <el-table-column
          prop="admin_name"
          label="用户名"
        >
          <template scope="scope">
            {{ scope.row.admin_name }}<el-tag v-if="scope.row.is_leader == 1" style="margin-left: 10px;">组长</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button v-if="scope.row.is_leader!=1" type="warning" size="mini" @click="settingcuoup(scope.row)">设置组长</el-button>
            <el-button type="primary" size="mini" @click="deletePitcher(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="alltableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

  </div>
</template>

<script>
import { getListOfPitchersInTheLaunchGroup } from '@/api/shortPlayReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { iaapitcherindex, iaapitcherindexcreate, iaapitcherindexdestroy } from '@/api/TKreleaseGroup.js'
import { adcopirw } from '@/api/taobaoLink.js'
export default {
  components: {
    PaginationRight
  },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      tableData: {},
      isP: true,
      pageinfo: {
        page: 1,
        page_size: 10,
        department_id: this.drawerItem.id
      },
      parameter: {
        page: 1,
        pageSize: 10,
        group_id: this.drawerItem.id
      },
      addParameter: {
        group_id: this.drawerItem.id,
        user_id: null
      },
      loading: false,
      alltableData: {}
    }
  },
  created() {
    this.getDataList()
    this.iaapitcherindexlist()
  },
  mounted() {
    setTimeout(() => {
      this.isP = false
    })
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getListOfPitchersInTheLaunchGroup(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    // 获取数据列表
    async iaapitcherindexlist() {
      this.loading = true
      const data = await iaapitcherindex(this.pageinfo)
      console.log('data', data)
      this.alltableData = data.data
      this.loading = false
    },
    fetchPageSize(s) {
      this.pageinfo.page_size = s
      this.iaapitcherindexlist()
    },

    fetchCurrentPage(s) {
      this.pageinfo.page = s
      this.iaapitcherindexlist()
    },

    // 添加投手
    addPitcher() {
      iaapitcherindexcreate({
        department_id: this.pageinfo.department_id,
        admin_id: this.addParameter.user_id
      }).then((res) => {
        console.log('res', res)
        this.iaapitcherindexlist()
        this.$message({
          message: '添加投手成功',
          type: 'success'
        })
      })
      // let text = null
      // this.addParameter.user_id || (text = '请选择投手')

      // text || await addOfPitchersInTheLaunchGroup({ ...this.addParameter })
      // text || this.getDataList()
      // text || (this.addParameter.user_id = null, this.app_id = null, this.app_ids = null)
      // this.$message({
      //   message: text || '添加投手成功',
      //   type: text ? 'warning' : 'success'
      // })
    },

    // 删除投手
    async deletePitcher(row) {
      await iaapitcherindexdestroy({ id: row.id })
      this.iaapitcherindexlist()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },
    settingcuoup(item) {
      console.log(item)
      adcopirw({
        id: item.id,
        is_leader: 1
      }).then((res) => {
        this.$message({
          message: '设置组长成功',
          type: 'success'
        })
        this.iaapitcherindexlist()
      })
    }
  }
}
</script>

<style scoped>
.details{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.details_add{
    width: 80%;
    margin: 0 auto;
}

.add_item{
   margin-bottom: 15px;
}

.item_title{
    display: inline-block;
    width: 100px;
}

.item_non{

}

.details_contentArea{
  margin-top: 50px;
}
</style>
